import React, { useEffect, useRef, useState } from 'react';
import * as Icons from '../../assets/svg/icons';
import SignatureCanvas from 'react-signature-canvas';
import { getNormalizedSignatureDataUrl } from '../../utils/helper/signatureCanvas';

export const PharmacistSignature = ({
	pharmacistSignature,
	setPharmacistSignature,
	showPharmacistSignature,
	setShowPharmacistSignature,
	signatureErrors,
	setSignatureErrors,
	selectedPharmacistID,
	pharmacistDetail,
	signingAsName
}) => {

	const sigRef = useRef();

	const getSelectedPharmacistName = () => {
		if (signingAsName) return signingAsName;
		if (selectedPharmacistID && pharmacistDetail?.length) {
			const selectedPharmacist = pharmacistDetail.find(
				pharmacist => Number(pharmacist.id) === Number(selectedPharmacistID) || pharmacist.id == selectedPharmacistID
			);
			return selectedPharmacist?.name || '';
		}
		return '';
	};

	const handlePharmacistSignatureEnd = () => {
		const signatureDataURL = getNormalizedSignatureDataUrl(sigRef.current);
		if (signatureDataURL) {
			setPharmacistSignature(signatureDataURL);
		}
	};

	const handleClearSignature = () => {
		sigRef?.current?.clear();
		setPharmacistSignature(null);
	};

	const handleToggleVisibility = () => {
		setShowPharmacistSignature(!showPharmacistSignature);
		if (!showPharmacistSignature) {
			handlePharmacistSignatureEnd();
		}
		setTimeout(() => {
			if (pharmacistSignature && sigRef?.current) {
				sigRef.current.fromDataURL(pharmacistSignature);
			}
		});
	};

	useEffect(() => {
		if (pharmacistSignature && setSignatureErrors) {
			setSignatureErrors(prev => ({ ...prev, pharmacistSign: null }));
		} else {
			if (sigRef?.current) {
				sigRef.current.clear();
			}
		}
	}, [pharmacistSignature]);

	return (
		<div
			className="w-fit p-4 bg-gray-100 rounded-lg mb-3 border border-gray-200"
			style={{ borderColor: signatureErrors?.pharmacistSign ? 'red' : undefined }}
		>
			{/* Header: Pharmacist Signature + caret (^ when expanded, v when collapsed) */}
			<div
				className="flex items-center justify-between cursor-pointer select-none"
				onClick={handleToggleVisibility}
			>
				<h2 className="text-base text-gray-800">Pharmacist Signature</h2>
				{showPharmacistSignature ? <Icons.PharmacistSignatureIcon1 /> : <Icons.PharmacistSignatureIcon2 />}
			</div>

			{showPharmacistSignature && (
				<>
					{/* White signature box with light grey border, CLEAR + pen icon inside bottom-right */}
					<div className="mt-3 relative w-full max-w-[300px] rounded-lg border border-gray-200 bg-white overflow-hidden">
						<SignatureCanvas
							penColor="black"
							clearOnResize={false}
							canvasProps={{ className: 'signature w-full', style: { height: 'auto', aspectRatio: '3 / 2' } }}
							ref={sigRef}
							onEnd={handlePharmacistSignatureEnd}
						/>
						<button
							type="button"
							onClick={handleClearSignature}
							className="absolute bottom-2 right-2 bg-white hover:bg-gray-50 text-gray-800 text-xs font-medium uppercase px-3 py-1.5 rounded flex items-center gap-1.5 border border-gray-200"
						>
							<Icons.ClearPatientSignatureIcon />
							CLEAR
						</button>
					</div>

					{/* Signing as [Name] - red text below signature area */}
					{getSelectedPharmacistName() && (
						<p className="mt-3 text-sm text-red-600 font-medium">
							Signing as {getSelectedPharmacistName()}
						</p>
					)}
				</>
			)}
		</div>
	);
};

export const Signature = ({
	patientSignature,
	setPatientSignature,
	showPatientSignature,
	setShowPatientSignature,
	handleClearSignature,
	sigRef
}) => {

	const [showSign, setShowSign] = useState(false);

	const handleSignatureEnd = () => {
		const signatureDataURL = getNormalizedSignatureDataUrl(sigRef.current);
		if (signatureDataURL) {
			setPatientSignature(signatureDataURL);
		}
		setShowSign(false);
	};

	const handleToggleVisibility = () => {
		setShowPatientSignature(!showPatientSignature);
		if (!showPatientSignature) {
			handleSignatureEnd();
			setShowSign(true);
		}
		setTimeout(() => {
			if (patientSignature && sigRef?.current) {
				sigRef.current.fromDataURL(patientSignature);
			}
		});
	};

	return (
		<div className="p-4 bg-gray-100 rounded-lg mb-3 border border-gray-200">
			<div
				className="flex items-center justify-between cursor-pointer"
				onClick={handleToggleVisibility}
			>
				<h2 className="text-base font-semibold text-gray-800">Signature</h2>
				{showPatientSignature ? <Icons.PharmacistSignatureIcon1 /> : <Icons.PharmacistSignatureIcon2 />}
			</div>
			{showPatientSignature && (
				<div className="mt-3">
					<div className="relative w-full max-w-[300px] rounded-lg border border-gray-200 bg-white overflow-hidden">
						<SignatureCanvas
							clearOnResize={false}
							penColor="black"
							canvasProps={{ className: 'signature w-full', style: { height: 'auto', aspectRatio: '3 / 2' } }}
							ref={sigRef}
							onEnd={handleSignatureEnd}
						/>
						<button
							type="button"
							onClick={handleClearSignature}
							className="absolute bottom-2 right-2 bg-gray-100 hover:bg-gray-200 text-gray-600 text-xs font-medium uppercase px-3 py-1.5 rounded flex items-center gap-1.5 border border-gray-200"
						>
							<Icons.ClearPatientSignatureIcon />
							CLEAR
						</button>
					</div>
				</div>
			)}
		</div>
	);
};
